module.exports = "<svg class=\"office\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" id=\"Layer_1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 512 512\" enable-background=\"new 0 0 512 512\" xml:space=\"preserve\"><path d=\"M0,224L96,64h320l96,160H0z M288,0h-64v32h64V0z M480,256v256H288V352h-64v160H32V256H480z M160,352H96v60h64V352z M416,352 h-64v64h64V352z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Office.svg
// module id = 516
// module chunks = 1